export const emailPattern = /^[a-z0-9_.]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
export const namePattern = /^[a-zA-Z0-9-' ]+('[a-zA-Z0-9-])?[-a-zA-Z0-9]*$/;
export const phonePattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4,6})$/;
